/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.0
 */
import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../../reducers/rootReducer';
import { IExtFilterReducer } from './reducers';
import { IExtFilterItem, IExtFilterMetaItem, ISubscriberMobileExtFilter } from './types/extFilterTypes';

export const getExtFilterState = (state: IRootReducer) => state.subscriberMobileExtFilter;

export const makeSelectIsClearFilterLoading = (): OutputSelector<IRootReducer, boolean,
    (state: IExtFilterReducer) => boolean> =>
    createSelector(
        getExtFilterState,
        (state: IExtFilterReducer) => {
            return state.api.isClearFilterLoading;
        },
    );

export const makeSelectExtFilterLoaded = (): OutputSelector<IRootReducer, boolean,
    (state: IExtFilterReducer) => boolean> =>
    createSelector(
        getExtFilterState,
        (state: IExtFilterReducer) => {
            return state.api.dataLoaded;
        },
    );
export const makeSelectExtFilter = (): OutputSelector<IRootReducer, ISubscriberMobileExtFilter,
    (state: IExtFilterReducer) => ISubscriberMobileExtFilter> =>
    createSelector(
        getExtFilterState,
        (state: IExtFilterReducer) => {
            return state.api.extFilter;
        },
    );
export const makeSelectExtFilterList = (): OutputSelector<IRootReducer, ISubscriberMobileExtFilter[],
    (state: IExtFilterReducer) => ISubscriberMobileExtFilter[]> =>
    createSelector(
        getExtFilterState,
        (state: IExtFilterReducer): ISubscriberMobileExtFilter[] => {
            return state.api.extFilterList;
        },
    );
export const makeSelectExtFilterMeta = (): OutputSelector<IRootReducer, IExtFilterMetaItem[],
    (state: IExtFilterReducer) => IExtFilterMetaItem[]> =>
    createSelector(
        getExtFilterState,
        (state: IExtFilterReducer) => {
            return state.api.extFilterMeta;
        },
    );
export const makeSelectExtFilterTabIndex = (): OutputSelector<IRootReducer, number | undefined,
    (state: IExtFilterReducer) => number | undefined> =>
    createSelector(
        getExtFilterState,
        (state: IExtFilterReducer) => {
            return state.api.tabIndex;
        },
    );
export const makeSelectExtFilterItems = (): OutputSelector<IRootReducer, IExtFilterItem[],
    (state: IExtFilterReducer) => IExtFilterItem[]> =>
    createSelector(
        getExtFilterState,
        (state: IExtFilterReducer) => {
            return state.filterConstructor.items;
        },
    );
export const makeSelectExtFilterId = (): OutputSelector<IRootReducer, string,
    (state: IExtFilterReducer) => string> =>
    createSelector(
        getExtFilterState,
        (state: IExtFilterReducer) => {
            return state.filterConstructor.id;
        },
    );
